// extracted by mini-css-extract-plugin
module.exports = {"applyAllDisclaimer":"PromotionProducts_applyAllDisclaimer__KgL3z text-reset"};